/* eslint-disable */
import React, { Component } from 'react';
import { Wrapper } from './checkoutForm.css.js';
import { CardElement, injectStripe } from 'react-stripe-elements';
// import { CardElement, injectStripe } from 'gatsby-plugin-stripe';

const createOptions = (fontSize, padding) => {
  return {
    style: {
      base: {
        fontSize,
        color: '#424770',
        letterSpacing: '0.025em',
        fontFamily: 'Source Code Pro, monospace',
        '::placeholder': {
          color: '#aab7c4',
        },
        padding,
      },
      invalid: {
        color: '#9e2146',
      },
    },
  };
};

class CheckoutForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      receipt_email: '',
      date: '',
      name: '',
      amount: '',
      description: '',
      paymentStatus: '',
      isLoading: false,
    };
    this.card = null;
    this.submit = this.submit.bind(this);
  }

  async submit(ev) {
    const { date, receipt_email, name } = this.state;
    const description = `${this.state.description} on date: ${date}`;
    const amount = this.state.amount * 100;
    let { token } = await this.props.stripe.createToken({ name });

    this.setState({ isLoading: true }, () =>
      fetch(process.env.BACKEND_URL, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'text/plain',
        }),
        body: JSON.stringify({
          token,
          amount,
          description,
          receipt_email,
        }),
      })
        .then(response => {
          // console.log(JSON.stringify({
          //   token,
          //   amount,
          //   description,
          //   receipt_email,
          // }))
          if (response.ok) {
            console.log('Success!');
            this.setState({ paymentStatus: 'Sent!', isLoading: false });
          } else {
            console.log('Error!');
            this.setState({
              paymentStatus:
                'Error- please email locksmithing@billy-jack.com for support',
              isLoading: false,
            });
          }
        })
        .catch(err => {
          console.log('Error!');
          this.setState({
            paymentStatus:
              'Error- please email locksmithing@billy-jack.com for support',
            isLoading: false,
          });
        })
    );
  }

  handleInput = evt => {
    // console.log('evt, target', evt.target)
    const { value, name } = evt.target;
    this.setState({ [name]: value, paymentStatus: '' });
  };

  render() {
    const {
      receipt_email,
      date,
      amount,
      name,
      isLoading,
      paymentStatus,
      description,
    } = this.state;
    const isDisabled = name && amount && date && receipt_email ? false : true;

    if (paymentStatus === 'Sent!' && !isLoading)
      return (
        <Wrapper>
          <h1>Payment Processed!</h1>
        </Wrapper>
      );
    if (
      paymentStatus ===
      'Error, please email locksmithing@billy-jack.com for support'
    )
      return (
        <Wrapper>
          <h1>{paymentStatus}</h1>
        </Wrapper>
      );

    return (
      <Wrapper>
        <div className="checkout">
          <div>
            <input
              name="name"
              type="text"
              placeholder="Name"
              value={name}
              onChange={this.handleInput}
            />
          </div>
          <div>
            <input
              name="receipt_email"
              type="email"
              placeholder="Email"
              value={receipt_email}
              onChange={this.handleInput}
            />
          </div>
          <br></br>
          <textarea
            name="description"
            type="text"
            placeholder="Invoice Description (Optional)"
            value={description}
            onChange={this.handleInput}
          />
          <div>
            <input
              name="date"
              type="text"
              placeholder="Date: MM/DD/YYYY"
              value={date}
              onChange={this.handleInput}
            />
          </div>
          <div>
            <input
              name="amount"
              type="number"
              placeholder="Amount e.g. $50.00"
              value={amount}
              onChange={this.handleInput}
            />
          </div>
          <br></br>
          <CardElement {...createOptions(this.props.fontSize)} />
          <button onClick={this.submit} disabled={isDisabled}>
            Submit
          </button>
        </div>
      </Wrapper>
    );
  }
}

export default injectStripe(CheckoutForm);
